// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cp7_","largestCol":"styles_largestCol__2YIFX","smallestCol":"styles_smallestCol__1jWbR"};